const FREE = 1;
const FLOW = 2;

export const MODE_CHILD_STYLE = {
    [FREE]: {
        position: 'absolute'
    },
    [FLOW]: {
        position: "relative",
        top: null,
        left: null,
    }
};

export const MODE_STYLE = {
    [FREE]: {
        position: 'relative'
    },
    [FLOW]: {
        'position': 'static',
        'display': 'flex',
        'flex-direction': 'column',
        'align-items': 'center',
        'background-size': '100%',
        'background-repeat': 'no-repeat',
        'margin': '0 auto',
    }
};

export const MODE_CLASS = {
    [FREE]: 'free-container',
    [FLOW]: 'flow-container'
};

export const MODE = {
    FREE,
    FLOW
};



// WEBPACK FOOTER //
// ./src/sdk/container/constant.js